/**
 * AutoFitText Alpine Component
 *
 * Automatically adjusts text size to fit within its container using binary search.
 * Handles responsive resizing with debounced resize events.
 *
 * Usage:
 * <div x-data="autoFitText({ minSize: 40, maxSize: 290 })">
 *     <span x-ref="text">Your text here</span>
 * </div>
 */
export default (config = {}) => ({
    minSize: config.minSize || 40,
    maxSize: config.maxSize || 290,
    heightMultiplier: config.heightMultiplier || 1.2,

    init() {
        this.fitText();

        // Debounced resize handler
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => this.fitText(), 100);
        });

        window.addEventListener("load", (event) => {
            this.fitText();
        });
    },

    fitText() {
        const textEl = this.$refs.text;
        const container = this.$el;

        if (!textEl || !container) return;

        const containerWidth = container.offsetWidth - 64; // Account for padding

        // Binary search for optimal font size
        let minSize = this.minSize;
        let maxSize = this.maxSize;
        let fontSize = maxSize;

        while (minSize <= maxSize) {
            fontSize = Math.floor((minSize + maxSize) / 2);
            textEl.style.fontSize = fontSize + 'px';

            if (textEl.scrollWidth <= containerWidth) {
                minSize = fontSize + 1;
            } else {
                maxSize = fontSize - 1;
            }
        }

        // Use the largest size that fits
        textEl.style.fontSize = maxSize + 'px';

        // Adjust container height based on text size
        const containerHeight = Math.max(150, maxSize * this.heightMultiplier);
        container.style.height = containerHeight + 'px';
    }
});
